/**
 * Checks if the current app is a Shopify Intent App or not
 */
export const checkIsIntentApp = (): boolean => {
  return process.env?.REACT_APP_SHOPIFY_INTENT === 'true';
};

/**
 * Get dev store name (localhost only)
 */
export const getDevStoreName = (): string => {
  return process.env?.REACT_APP_SHOPIFY_DEV_STORE_NAME ?? 'olc-develop';
}


/**
 * Returns the Open Letter Connect website uri
 */
export const getOlcWebsite = (): string => {
  return process.env?.REACT_APP_OLC_WEBSITE ?? 'https://openletterconnect.com/';
}
